import React from 'react';
import { Row, Col } from '@vds/grids';
import PropTypes from 'prop-types';

import { allowOnlyValidNumber } from '../../../../common/validation';
import ReqInput from '../../../../common/ReqInput';
import { viewport, isACPEligibile, isVFEligibile } from '../../../../common/Helpers/index';
import '../creditCheck.css';

const CreditCheckForm = (props) => {
  const type = viewport();
  let errorText = '';
  if (isVFEligibile()) {
    if (props?.state?.vfSSNCheckValue === false && props.state.showSsnError === false) {
      errorText = props?.vfSSNErrorMessage;
    } else if (props.state.showSsnError) {
      errorText = props.ssnErrorText;
    }
  } else if (isACPEligibile()) {
    if (props?.state?.acpSSNCheckValue === false && props.state.showSsnError === false) {
      errorText = props?.acpSSNErrorMessage;
    } else if (props.state.showSsnError) {
      errorText = props.ssnErrorText;
    }
  } else {
    errorText = props.ssnErrorText;
  }
  return (
    <Row className="marginTop35">
      <Col xs={12}>
        <Row className={`${type === 'mobile' ? 'noLeftMargin noRightMarginCreditForm' : ''} CreditCheckFormWrapper`}>
          <Col className="ssnDobWrapper notranslate" aria-live="assertive">
            <ReqInput
              id="dob"
              type="date"
              dateFormat="mmddyyyy"
              isPiiMask
              error={props.state.showDobError}
              errorText={props.belowAgeError ? props.belowAgeErrorText : props.dobErrorText}
              required
              label={props.dob_new}
              onChange={(e) => props.onChangeTextBox('dob', e)}
              // data-cs-mask
              isCsMask
              success={props.state.dob}
              defaultValue={props?.state?.dob}
            />
          </Col>
        </Row>
        <Row className={`${type === 'mobile' ? 'noLeftMargin noRightMarginCreditForm' : ''} CreditCheckFormWrapper`}>
          <Col className={type === 'mobile' ? 'ssnDobWrapperAlt' : 'ssnDobWrapper'} aria-live="assertive">
            <ReqInput
              id="ssn"
              type="password"
              isPiiMask
              error={
                isVFEligibile()
                  ? props.state.showSsnError || props?.state?.vfSSNCheckValue === false
                  : isACPEligibile()
                    ? props.state.showSsnError || props?.state?.acpSSNCheckValue === false
                    : props.state.showSsnError
              }
              errorText={errorText}
              required
              maxLength={9}
              onKeyDown={(name, e) => allowOnlyValidNumber(e)}
              label={props.ssn_new}
              onChange={(e) => props.onChangeTextBox('ssn', e)}
              onPaste={(e) => {
                e.preventDefault();
                return false;
              }}
              // data-cs-mask
              isCsMask
              // mask=""
              success={props.state.ssn}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

CreditCheckForm.propTypes = {
  state: PropTypes.object,
  dob_new: PropTypes.string,
  ssn_new: PropTypes.string,
  dobErrorText: PropTypes.string,
  ssnErrorText: PropTypes.string,
  onChangeTextBox: PropTypes.func,
  belowAgeError: PropTypes.string,
  belowAgeErrorText: PropTypes.string,
  acpSSNErrorMessage: PropTypes.string,
  vfSSNErrorMessage: PropTypes.string,
};

export default CreditCheckForm;
